import {ApiHelper, axiosInstance } from '../../utils/ApiHelper'
import { push, goBack } from 'react-router-redux'
import { SubmissionError, change } from 'redux-form'
import { message } from 'antd';
import { getTrips } from '../../trips/actions'

export function deleteFavoritePlace (id) {
  return dispatch => {
    dispatch({type: 'DELETE_FAVE_PLACE_REQUEST', id})
    return ApiHelper
      .deleteFavoritePlace(id)
      .then(json => {
        dispatch({ type: 'FAVE_PLACE_DELETED', id })
        dispatch(push(`/account/favorite-places`))
      })
  }
}

export function updateFavoritePlace (place) {

      if (!(place.address||place.street||place.city)) throw new SubmissionError({
        miles: 'address is empty',
        _error: 'Please enter an address.'
      })

  return dispatch => {
    dispatch({type: 'UPDATE_FAVE_PLACE_REQUEST', place})

    ApiHelper.updateFavoritePlace(place)
      .then(json => {

        dispatch({
          type: 'UPDATE_FAVE_PLACE_SUCCESS',
          place
       })

       // if (place.addedOnTripList) {
       // }
       dispatch({type:'UPDATE_TRIP_BATCH_SUCCESS', trips: json.data.trips})
       dispatch({type: 'HIDE_MODAL_2'})

       message.success('Updated place successfully.', 10)

    })
  }
}

export function createFavoritePlace (place) {
  if (!(place.address||place.street||place.city)) throw new SubmissionError({
    miles: 'address is empty',
    _error: 'Please enter an address.'
  })


  return dispatch => {
    dispatch({type: 'ADD_FAVE_PLACE_REQUEST', place})
    return ApiHelper.createFavoritePlace(place)
      .then(json => {
        dispatch({
          type:'ADD_FAVE_PLACE_SUCCESS',
          place: json.data,
          receivedAt: Date.now(),
       })

       message.success('Created new place successfully.', 3)

       dispatch({type:'UPDATE_TRIP_BATCH_SUCCESS', trips: json.data.trips})

       if (place.addedOnTripList) {
         dispatch({type: 'HIDE_MODAL_2'})
         return json
       }
       dispatch(push(`/account/favorite-places`))

       return json
     }
   )
  }
}

export function listFavoritePlaces() {
  return dispatch => {
    dispatch({type: 'FAVE_PLACES_REQUESTED'})
    return ApiHelper.listFavoritePlaces()
      .then(json => dispatch({
        type: 'RECEIVE_FAVE_PLACES',
        user: {
          places: json.data
        }
      }))
  }
}



// WEBPACK FOOTER //
// ./src/account/favorite-places/actions.js